import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'
import { InfiniteScrollDirective } from 'ngx-infinite-scroll'
import { NgPipesModule } from 'ngx-pipes'

import { ComponentsModule } from '../../components/components.module'
import { OurSubscriptionsComponent } from '../../pages/home/components/our-subscriptions/our-subscriptions.component'
import { FormatAuthorNamePipe } from '../../shared/pipes/format-author-name.pipe'
import { SharedModule } from '../../shared/shared.module'
import { AuthorDetailsComponent } from './author-details/author-details.component'
import { MainInfoComponent } from './author-details/components/main-info/main-info.component'
import { AuthorsOverviewComponent } from './authors-overview/authors-overview.component'
import { AuthorItemComponent } from './authors-overview/components/author-item/author-item.component'
import { AuthorsListComponent } from './authors-overview/components/authors-list/authors-list.component'
import { AuthorsRoutingModule } from './authors-routing.module'

@NgModule({
  imports: [
    CommonModule,
    AuthorsRoutingModule,
    ComponentsModule,
    InfiniteScrollDirective,
    SharedModule,
    ReactiveFormsModule,
    NgPipesModule,
    FormatAuthorNamePipe,
    TranslatePipe,
    OurSubscriptionsComponent,
    AuthorsOverviewComponent,
    AuthorsListComponent,
    AuthorItemComponent,
    AuthorDetailsComponent,
    MainInfoComponent,
  ],
  exports: [AuthorsOverviewComponent, AuthorDetailsComponent],
})
export class AuthorsModule {}
